'use client';

import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

export default function FileUpload({
    filesState,
    receivedFiles,
    deleteFile
}) {
    const onDrop = useCallback((acceptedFiles, fileRejections) => {
        if (fileRejections?.length) {
            alert('Invalid file type or size exceeded (Max 20MB)');
            return;
        }

        if (acceptedFiles?.length) {
            receivedFiles(acceptedFiles);
        }
    }, [receivedFiles]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple: false,
        maxSize: 20 * 1024 * 1024,
        accept: {
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
            'application/vnd.ms-excel': ['.xls'],
            'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
            'application/vnd.ms-excel.sheet.binary.macroEnabled.12': ['.xlsb'],
        }
    });

    return (
        <div>

            {!filesState?.length && <h2 className="text-base font-semibold mb-2.5">Upload File</h2>}
            {!filesState?.length && <p className="text-xs text-gray-1100 mb-[5px]" >Max size of 20MB</p>}

            {!filesState?.length && (
                <div
                    {...getRootProps()}
                    className="border border-dashed border-gray-300 rounded-xs h-[120px] flex flex-col items-center justify-center text-center cursor-pointer hover:border-gray-400"
                >
                    <input {...getInputProps()} />
                    <div className="text-gray-400 mb-1.5 text-xl w-4 h-4 fill-[#53565a]">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M448 346.535l-82.745 82.745-90.51-90.509 237.255-237.255 237.254 237.255-90.509 90.509-82.746-82.745v293.491h-128v-293.491zM128 704.006h128v64h512v-64h128v192h-768v-192z "></path></svg>
                    </div>

                    <p className="text-gray-600 text-xs">
                        {isDragActive ? 'Drop file here...' : 'Drag and Drop here or'}
                    </p>
                </div>
            )}

            {!filesState?.length && (
                <button
                    {...getRootProps()}
                    className="mt-2 bg-green-900 hover:bg-green-1000 text-white px-[11px] py-1.5 rounded-xs text-sm"
                >
          Choose File
                    <input {...getInputProps()} />
                </button>
            )}

            {filesState?.length > 0 && (
                <div className="mt-[7px] flex items-center justify-between">
                    <div className='flex flex-col'>
                        <div className="flex items-center gap-3">

                            <div className="w-6 h-6 bg-gray-1100 flex items-center justify-center rounded">
                                <span className="text-white text-lg">…</span>
                            </div>

                            <div>
                                <p className="text-sm font-medium">
                                    {filesState[0].name}
                                </p>
                            </div>
                            <button
                                onClick={deleteFile}
                                className="text-gray-1100 text-sm font-bold ml-20"
                            >
                                ✕
                            </button>
                        </div>
                        <p className="text-xs text-gray-1100 mt-2">
                            {(filesState[0].size / 1024).toFixed(2)} kB
                        </p>
                    </div>

                </div>
            )}

        </div>
    );
}
